import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';

interface LinkItem {
    name: string;
    link: string;
}

export default class DIWLinks extends TKCustomElementFactory {
    fieldCount: number;
    form?: HTMLFormElement;
    fieldsContainer?: HTMLElement;
    addFieldButton?: HTMLButtonElement;
    deleteFieldButtons: HTMLButtonElement[];
    template?: HTMLTemplateElement;
    type: string;
    existingData?: string;

    constructor() {
        super();
        this.form = this.querySelector('form') || undefined;
        this.fieldsContainer = this.querySelector('[data-tk-fields-container]') || undefined;
        this.fieldCount = this.fieldsContainer?.childElementCount || 1;
        this.addFieldButton = this.form?.querySelector('[data-tk-add-field]') || undefined;
        this.deleteFieldButtons = Array.from(this.querySelectorAll('[data-tk-delete]')) || undefined;
        this.template = this.querySelector('[data-tk-field-template]') || undefined;
        this.type = this.getAttribute('data-tk-type') || 'editlinks';
        this.existingData = this.getAttribute('data-tk-existing-data') || undefined;
    }

    connectedCallback(): void {
        if (!this.form || (this.type == 'editlinks' && !this.fieldsContainer)) {
            throw new Error('DIWLinks: form or fields container not found');
        }

        this.pushListener({
            event: 'submit',
            element: this.form,
            action: this.handleSubmit.bind(this),
        });

        if (this.addFieldButton && this.template) {
            this.pushListener({
                event: 'click',
                element: this.addFieldButton,
                action: this.addField.bind(this),
            });
        }

        this.registerDeleteButtons(this.deleteFieldButtons);
    }

    registerDeleteButtons(btns: HTMLButtonElement[]) {
        btns.forEach((btn) => {
            this.pushListener({
                event: 'click',
                element: btn,
                action: this.deleteField.bind(this),
            });
        });
    }

    addField(e: Event): void {
        e.preventDefault();
        this.fieldCount++;

        if (!this.template) {
            throw new Error('DIWLinks: template not found');
        }

        const clone = this.template.content.cloneNode(true) as DocumentFragment;

        // Replace {{ID}} placeholders in all attributes
        Array.from(clone.querySelectorAll('*')).forEach((element) => {
            Array.from(element.attributes).forEach((attr) => {
                attr.value = attr.value.replace(/\{\{ID\}\}/g, String(this.fieldCount));
            });
        });

        this.fieldsContainer!.appendChild(clone);

        this.registerDeleteButtons(
            Array.from(this.fieldsContainer!.lastElementChild!.querySelectorAll('[data-tk-delete]')),
        );
    }

    deleteField(e: Event): void {
        const target = e.target as HTMLElement;
        const fieldset = target.closest('[data-tk-fieldset]');

        fieldset && fieldset.remove();
    }

    handleSubmit(e: Event): void {
        e.preventDefault();

        const formData = new FormData(this.form);
        let items: LinkItem[] = [];

        // Group entries by field number to pair name with link
        const fieldMap = new Map<string, Partial<LinkItem>>();

        formData.forEach((value, key) => {
            const [fieldType, fieldNum] = key.split('-').slice(-2);

            if (!fieldMap.has(fieldNum)) {
                fieldMap.set(fieldNum, {});
            }

            if (fieldType == 'link') {
                value = value.toString().split(window.location.host)[1] || value;
            }

            fieldMap.get(fieldNum)![fieldType as keyof LinkItem] = String(value);
        });

        fieldMap.forEach((field) => {
            if (field.name && field.link) {
                items.push(field as LinkItem);
            }
        });

        console.log(items);

        if (this.type === 'addpage' && this.existingData) {
            const existingJson = JSON.parse(this.existingData).items;
            items = existingJson.concat(items);
        }

        const payload = {
            data: JSON.stringify({ items }),
        };

        console.log(payload);

        fetchRequest({
            requestURL: this.form!.action,
            resolveHandler: this.updateLinks.bind(this),
            payload,
        });
    }

    updateLinks() {
        window.location.reload();
    }
}
